import styled from 'styled-components';
import { XIColors } from '@inmoment/the-kitchen';
const { white, orca } = XIColors;

interface IconWrapperProps {
  isSun: boolean;
}
export const IconWrapper = styled.div`
  user-select: none;
  position: absolute;
  box-sizing: border-box;
  height: 36px;
  width: 36px;
  left: 18px;
  bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  background: ${(props: IconWrapperProps) => (props.isSun ? white.light[90] : orca.light[90])};
  &:hover {
    background: ${(props: IconWrapperProps) => (props.isSun ? white.light[80] : orca.light[80])};
  }
`;
